"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Sparkles } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const playZones = [{
  title: "Roof Repair & Maintenance",
  benefit: "Extend the Life of Your Home's Protection",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roof_repair_service.png"
}, {
  title: "Siding Installation",
  benefit: "Premium Curb Appeal & Energy Efficiency",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/siding_installation_service.png"
}, {
  title: "Gutter Systems",
  benefit: "Advanced Water Management Solutions",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/gutter_systems_service.png"
}];
export default function ExploreOurPlayZones() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223760" id="our-specialized-services" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div ref={ref} className={`mb-16 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-6">
            Expert Services + Free Estimates for All Projects
          </h2>
          <p className="font-default text-lg text-secondary max-w-2xl mx-auto">
            Eagle Exteriors provides industry-leading craftsmanship for your home's 
            most critical exterior components, ensuring lasting durability and style.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {playZones.map((zone, i) => <div key={i} data-index={i} className={`group relative overflow-hidden rounded-lg bg-card shadow-md transition-all duration-500 hover:shadow-xl hover:-translate-y-2 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <AspectRatio ratio={1.2 / 1}>
                {}
                <div className="absolute top-4 left-4 z-20">
                  <div className="bg-secondary text-secondary-foreground px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-lg shadow-sm">
                    Free Consultation Included
                  </div>
                </div>

                <img src={zone.image} data-wvc-srcset={`${zone.image}-wvc-srcset`} data-wvc-sizes={`${zone.image}-wvc-sizes`} alt={zone.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-110" />

                {}
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground/90 via-foreground/40 to-transparent p-8 pt-24 transition-opacity duration-300 group-hover:opacity-0">
                  <h3 className="font-default text-2xl font-bold transition-transform duration-300 group-hover:translate-x-[10px] text-white mb-2">
                    {zone.title}
                  </h3>
                  <p className="font-default text-sm text-white/90 font-medium">
                    {zone.benefit}
                  </p>
                </div>

                {}
                <div className="absolute inset-0 flex flex-col items-center justify-center bg-foreground/95 p-8 text-center opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <Sparkles className="w-10 h-10 text-secondary mb-4 animate-pulse" />
                  <h3 className="font-default text-3xl font-bold text-white mb-4">
                    {zone.title}
                  </h3>
                  <div className="h-px w-16 bg-secondary/50 mb-4" />
                  <p className="font-default text-xl font-medium text-white/90">
                    {zone.benefit}
                  </p>
                </div>
              </AspectRatio>
            </div>)}
        </div>

        <div className="mt-12 text-center">
          <p className="font-default text-lg font-semibold text-primary">
            All estimates are 100% free and include detailed pricing
          </p>
        </div>
      </div>
    </section>;
}